(function() {

  var base_url = (function() {
    var scripts = document.getElementsByTagName("script");
    var me = scripts[scripts.length - 1];
    var parts = me.src.split("/");
    parts.pop();
    return parts.join("/") + "/";
  })();

  /**
   * HACK: run async so that main / distributable is interpreted and
   * modules are registered--and, therefore, require.specified() can work.
   */
  require.config();
  setTimeout(function() {
    var is_built = require.specified("config");
    var config_key = is_built ? "config" : base_url + "config.js";

    require([config_key], function(Config) {
      Config.baseUrl = base_url;
      require.config(Config);
      main();
    });
  }, 10);

  function main() {
    require([
      "settings",
      "maps",
      'databag',
      "domReady!"
    ], function(Settings, Maps, Databag) {
      Maps.render_maps(Settings.ngpvanevents);
      Databag.init();
    });
  }
})();

define("main", function(){});

